import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Developers } from './Developers';
import './main.css';

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <Developers />
    </StrictMode>,
  );
}
